 import axiosInstance from './../interceptor/interceptor';

export const accountService = {
  getAccountList,
};

const config = {
  // headers: {
  //   "Content-Type": "application/json",
  // },
};
// , "Authorization": `bearer ${localStorage.getItem('ed_token')}`

function getAccountList(obj) {
  return axiosInstance
    .get(
      `api?method=fetch_user_accounts&user_id=${encodeURIComponent(obj.user_id)}`
    );
}

